import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../../context/AuthContext';

const SeoTasks = ({ siteId, dateFrom, dateTo, currentLang, onStats }) => {
  const { token, API_URL } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      return new Date(dateString).toLocaleDateString('ru-RU');
    } catch (error) {
      return dateString;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 0: return 'Ожидает';
      case 1: return 'В работе';
      case 2: return 'Завершена';
      case 99: return 'Отменена';
      default: return '-';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 0: return 'bg-yellow-100 text-yellow-800';
      case 1: return 'bg-blue-100 text-blue-800';
      case 2: return 'bg-green-100 text-green-800';
      case 99: return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        setLoading(true);
        setError('');
        const params = new URLSearchParams();
        params.append('d_start_from', dateFrom);
        params.append('d_start_to', dateTo);
        params.append('limit', '1000');
        params.append('sort_field', 'd_start');
        params.append('sort_direction', 'asc');
        const response = await fetch(`${API_URL}${currentLang}/seo/sites/${siteId}/tasks?${params.toString()}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });
        const data = await response.json();
        if (response.ok && data.success) {
          const tasksData = data.data.tasks || [];
          setTasks(tasksData);
          
          // Передаем количество задач в родительский компонент
          if (onStats) {
            onStats({ tasksCount: tasksData.length });
          }
        } else {
          throw new Error(data.message || 'Ошибка загрузки задач');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    if (siteId && dateFrom && dateTo) fetchTasks();
  }, [siteId, dateFrom, dateTo, currentLang, token, API_URL]);

  return (
    <div className="bg-white p-8">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Задачи по комплексному сопровождению сайта за период</h2>
        <p className="text-gray-600 mb-4">Список задач, поставленных и выполненных за период отчёта</p>
      </div>
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="flex items-center space-x-2">
            <span className="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></span>
            <span className="text-gray-600">Загрузка задач...</span>
          </div>
        </div>
      ) : error ? (
        <div className="flex justify-center items-center h-64">
          <div className="text-center text-red-500">{error}</div>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="border px-3 py-2 text-xs font-medium text-gray-700">Задача</th>
                <th className="border px-3 py-2 text-xs font-medium text-gray-700">Статус</th>
                <th className="border px-3 py-2 text-xs font-medium text-gray-700">Прогресс</th>
                <th className="border px-3 py-2 text-xs font-medium text-gray-700">Дата начала</th>
                <th className="border px-3 py-2 text-xs font-medium text-gray-700">Дата окончания</th>
              </tr>
            </thead>
            <tbody>
              {tasks.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center py-8 text-gray-500">Задачи не найдены</td>
                </tr>
              ) : (
                tasks.map((task) => (
                  <tr key={task.id} className="hover:bg-gray-50">
                    <td className="border px-3 py-2 text-xs text-gray-900 font-medium">
                      <div className="text-sm">{task.name}</div>
                      <div className="text-xs text-gray-500" dangerouslySetInnerHTML={{ __html: task.text }}></div>
                    </td>
                    <td className="border px-3 py-2 text-xs">
                      <span className={`px-2 py-1 text-xs font-bold rounded-full ${getStatusColor(task.status)}`}>{getStatusText(task.status)}</span>
                    </td>
                    <td className="border px-3 py-2 text-xs">
                      <div className="w-16 bg-gray-200 rounded-full h-2 inline-block align-middle mr-2">
                        <div className="bg-blue-600 h-2 rounded-full" style={{ width: `${task.pct}%` }}></div>
                      </div>
                      <span className="text-xs text-gray-600 align-middle">{task.pct}%</span>
                    </td>
                    <td className="border px-3 py-2 text-xs text-gray-900">{formatDate(task.d_start)}</td>
                    <td className="border px-3 py-2 text-xs text-gray-900">{formatDate(task.d_end)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SeoTasks; 